import Immutable from 'seamless-immutable';
import _ from 'lodash';
import { getMutable } from '../../common/Utils';

/**
 * Create a RulesetModel from provided data
 * @param {Object} data - the data to create the ruleset from
 * @returns {Ruleset} - the created ruleset
 */
function create(data = {}) {
  const result = _.clone(data);
  return Immutable(result, { prototype: model });
}

/**
 * Transform a backend ruleset object into a RulesetModel
 * @param {Object} ruleset - the backend ruleset object
 * @returns {Ruleset} - the deserialized ruleset
 */
function deserialize(ruleset) {
  const result = _.pick(ruleset, _keys);
  result.targetingRules = JSON.parse(result.targetingRules);
  return create(result);
}

/**
 * Transform a RulesetModel into a backend ruleset object
 * @param {Ruleset} ruleset - the ruleset to serialize
 * @returns {Object} - the serialized ruleset
 */
function serialize(ruleset) {
  const result = getMutable(ruleset, { deep: true });
  // passing an empty string if targetingRules is not set is intentional.
  // we want to send this field anyway to the backend, so it will be up to date, for example on deletion.
  result.targetingRules = JSON.stringify(result.targetingRules) || '';
  return _.pick(result, _keys);
}

const model = {};

/**
 * An array of keys on the API Ruleset object that should be shared between the API requests and responses
 */
const _keys = ['id', 'name', 'modifiedBy', 'lastUpdated', 'targetingRules', 'usedIn'];

export default {
  create,
  deserialize,
  serialize,
};
